import { createContext, useContext } from 'react';
import type { MatchOverviewLeague, MatchOverviewMatch } from '@/types/matchOverview';

/**
 * Shared state for the standalone match page (`/match/:matchId/*`).
 * The overview record is fetched (and polled while live) once in the layout;
 * tabs read it here.
 */
export interface MatchOverviewContextType {
  match: MatchOverviewMatch;
  league: MatchOverviewLeague;
  matchId: string;
}

export const MatchOverviewContext = createContext<MatchOverviewContextType | undefined>(undefined);

export function useMatchOverviewContext() {
  const ctx = useContext(MatchOverviewContext);
  if (!ctx) {
    throw new Error('useMatchOverviewContext must be used within MatchOverviewLayout');
  }
  return ctx;
}
